/* eslint-disable @next/next/no-img-element */
import classNames from 'classnames';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  LINK_LIVINGSOCIAL,
  LINK_LIVINGSOCIAL_IE,
  LINK_WOWCHER,
  LINK_WOWCHER_IE,
} from '../../config/links/links';
import { BRAND_LIVINGSOCIAL } from '../../config/setup/setup';
import ThemeContext from '../../providers/ThemeProvider';

const HeaderFlags = ({ countryCode, isMobileHidden }) => {
  const theme = useContext(ThemeContext);
  const ukFlag = theme.images.flags.headerflaguk;
  const ieFlag = theme.images.flags.headerflagie;
  const isLivingSocial = process.env.NEXT_PUBLIC_BRAND === BRAND_LIVINGSOCIAL;
  const componentClass = classNames('flag-container', {
    'flag-container--hidden': !theme.switches.showFlags,
    'flag-container--hidden-mobile': isMobileHidden,
  });

  return (
    <div
      aria-label="Country Selection"
      className={componentClass}
      data-qa="countrySelection"
    >
      <Link
        href={
          isLivingSocial
            ? LINK_LIVINGSOCIAL_IE[process.env.NEXT_PUBLIC_ENVIRONMENT]
            : LINK_WOWCHER_IE[process.env.NEXT_PUBLIC_ENVIRONMENT] ?? ''
        }
      >
        <a
          href={
            isLivingSocial
              ? LINK_LIVINGSOCIAL_IE[process.env.NEXT_PUBLIC_ENVIRONMENT]
              : LINK_WOWCHER_IE[process.env.NEXT_PUBLIC_ENVIRONMENT] ?? ''
          }
        >
          <img
            alt="Ireland Flag select"
            aria-label="IE Flag"
            className={`flag ${countryCode === 'ie' ? 'active' : ''}`}
            data-qa="irelandFlagSelection"
            loading="lazy"
            src={`${ieFlag}`}
          />
        </a>
      </Link>
      <Link
        href={
          isLivingSocial
            ? LINK_LIVINGSOCIAL[process.env.NEXT_PUBLIC_ENVIRONMENT]
            : LINK_WOWCHER[process.env.NEXT_PUBLIC_ENVIRONMENT] ?? ''
        }
      >
        <a
          href={
            isLivingSocial
              ? LINK_LIVINGSOCIAL[process.env.NEXT_PUBLIC_ENVIRONMENT]
              : LINK_WOWCHER[process.env.NEXT_PUBLIC_ENVIRONMENT]
          }
        >
          <img
            alt="UK Flag select"
            aria-label="UK Flag"
            className={`flag ${countryCode === 'gb' ? 'active' : ''}`}
            data-qa="ukFlagSelection"
            loading="lazy"
            src={`${ukFlag}`}
          />
        </a>
      </Link>

      <style jsx>{`
        .flag-container {
          text-align: center;
          color: ${theme.colors.primary};
          font-size: 12px;
          text-transform: ${theme.text.transform};
        }

        .flag-container .flag {
          width: 46px;
          margin-left: 10px;
        }

        .flag-container .flag.active {
          border: 1px solid ${theme.colors.primary};
          padding: 2px;
          border-radius: 5px;
        }

        .flag-container--hidden {
          display: none;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .flag-container--hidden-mobile {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default HeaderFlags;

HeaderFlags.propTypes = {
  countryCode: PropTypes.string,
  isMobileHidden: PropTypes.bool,
};

HeaderFlags.propTypes = {
  countryCode: PropTypes.oneOf(['gb', 'ie']),
};
